import { createQueryKeys } from "@lukemorales/query-key-factory";
import { IDropdownModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

export const opac = createQueryKeys("opac", {
  getOPACLibrary: () => ({
    queryKey: ["library"],
    queryFn: () => api.get<IDropdownModel[]>(endpoints.OPAC.getOPACLibrary),
  }),

  getMaterialTypeByLibraryID: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.OPAC.getMaterialTypeByLibraryID}/${Id}`
      ),
  }),

  getOPACLanguage: () => ({
    queryKey: ["opacLanguage"],
    queryFn: () => api.get<IDropdownModel[]>(endpoints.OPAC.getOPACLanguage),
  }),
  getOPACInstitute: () => ({
    queryKey: ["opacInstitute"],
    queryFn: () => api.get<IDropdownModel[]>(endpoints.OPAC.getOPACInstitute),
  }),
  getOPACDepartmentbyInstituteID: (id: string | number) => ({
    queryKey: [{ id }],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.OPAC.getOPACDepartmentbyInstituteID}/${id}`
      ),
  }),
});

